import { useCallback, useEffect, useMemo, useState } from "react";
import { endpoints } from "../../config";
import useAjaxRequest, { GET } from "./useAjaxRequest";

export const TITULO_PATTERN = /(\d{3})\.?(\d{3})\.?(\d{7})-?(\d{1})/gis;

export default () => {
  const {
    response: { error: errorExtracoes, data: dataExtracoes },
    loading: loadingExtracoes,
    performRequest,
  } = useAjaxRequest();

  const {
    response: { error: errorResultados, data: dataResultados },
    loading: loadingResultados,
    performRequest: performResultadosRequest,
  } = useAjaxRequest();

  const [{ plano, dataBusca, titulo }, setDataBusca] = useState({});

  const dataSorteios = useMemo(
    () => (Array.isArray(dataExtracoes) ? dataExtracoes : []),
    [dataExtracoes]
  );

  const resultados = useMemo(
    () =>
      Object.keys({ ...dataResultados }).length && plano
        ? dataResultados
        : null,
    [dataResultados, plano]
  );

  const dataUltimoSorteio = useMemo(
    () => (dataSorteios.length ? dataSorteios[dataSorteios.length - 1] : ""),
    [dataSorteios]
  );

  const contemplado = useMemo(() => {
    if (!titulo || !resultados) {
      return false;
    }

    const numerosSorte = titulo.replace(TITULO_PATTERN, "$3");

    return resultados.combinacoes
      ?.map(({ combinacoes_sorteadas: c }) =>
        c.map(({ descricao: combinacao }) => combinacao)
      )
      .reduce((a, b) => [...a, ...b], [])
      .reduce(
        (...[a, combinacao]) => a || numerosSorte.includes(combinacao),
        false
      );
  }, [resultados, titulo]);

  const getDatas = useCallback(
    (params) => {
      const options = {
        method: GET,
        url: endpoints.getSorteiosRealizadosEndPoint(params),
      };
      return performRequest(options);
    },
    [performRequest]
  );

  const getResults = useCallback(
    (params) => {
      const options = {
        method: GET,
        url: endpoints.getResultadoSorteiosEndPoint({ ...params }),
      };
      return performResultadosRequest(options);
    },
    [performResultadosRequest]
  );

  const setBusca = useCallback(
    (busca) => {
      setDataBusca((current) => ({ ...current, ...busca }));

      if (busca?.plano?.value) {
        getResults({ ...busca });
      }
    },
    [getResults]
  );

  useEffect(() => {
    if (plano) {
      getDatas({
        plano,
      });
    }
  }, [getDatas, plano]);

  return {
    error: { ...errorExtracoes, ...errorResultados },
    loading: loadingExtracoes || loadingResultados,
    dataSorteios,
    dataUltimoSorteio,
    resultados,
    dataBusca,
    setBusca,
    contemplado,
    plano,
    titulo,
  };
};
